module.exports = __webpack_public_path__ + "img/scene-icon-3.ec517011.png";